import { theme } from '@/styles';
import React from 'react';
import styled from 'styled-components';

function SearchAddressNoti() {
  return (
    <SearchAddressNotiWrap>
      <TitleWrap>
        <Title>Tip</Title>
        <Subtitle>아래와 같은 방법으로 검색해 보세요.</Subtitle>
      </TitleWrap>
      <TipWrap>
        <Tip>
          <BulletWrap>
            <Bullet />
            <div>도로명 + 건물번호</div>
          </BulletWrap>
          <Example>{'예) 성암로 179, 방배로 285'}</Example>
        </Tip>
        <Tip>
          <BulletWrap>
            <Bullet />
            <div>지역명(동/리) + 번지</div>
          </BulletWrap>
          <Example>{'예) 상암동 1623, 방배동 757'}</Example>
        </Tip>
        <Tip>
          <BulletWrap>
            <Bullet />
            <div>지역명(동/리) + 건물명(아파트명)</div>
          </BulletWrap>
          <Example>{'예) 상암동 한샘상암, 방배동 한샘빌딩'}</Example>
        </Tip>
      </TipWrap>
    </SearchAddressNotiWrap>
  );
}

const SearchAddressNotiWrap = styled.div`
  background-color: ${theme.colors.neutral_colors.gray[50]};
  width: 490px;
  height: 230px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.div`
  ${theme.typography.button.lg_b};
  color: ${theme.colors.accent_colors.red.default};
`;

const Subtitle = styled.div`
  ${theme.typography.subtitle7};
`;

const TipWrap = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${theme.typography.caption1};
`;

const Tip = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const BulletWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const Example = styled.div`
  margin-left: 6px;
  color: ${theme.colors.neutral_colors.gray[700]};
`;

const Bullet = styled.div`
  border-radius: 100%;
  background-color: ${theme.colors.neutral_colors.primary};
  width: 2px;
  height: 2px;
`;

export default SearchAddressNoti;
